<template>
  <LayoutDashboard title="Orçamentos">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarOrcamento"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-orcamento')"
          >Cadastrar</v-btn
        >
        <v-spacer></v-spacer>
        <h3>Orçamentos: {{ getOrcamentos.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getOrcamentos.current_page"
          :length="getOrcamentos.last_page"
          @input="listarOrcamentos({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.id"
                    outlined
                    dense
                    class="mt-2"
                    label="Cód."
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </th>
                <th width="30%">
                  <v-text-field
                    v-model="dataPagina.cliente"
                    outlined
                    dense
                    class="mt-2"
                    label="Cliente"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.data"
                    outlined
                    dense
                    class="mt-2"
                    label="Data"
                    type="date"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th>Total</th>
                <th>
                  <v-select
                    :items="['', ...getFuncionarios]"
                    item-value="id"
                    item-text="nome_abreviado"
                    v-model="dataPagina.funcionarioId"
                    outlined
                    dense
                    label="Vendedor"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-select>
                </th>
                <th>
                  <v-select
                    :items="['', 'EM ABERTO', 'FINALIZADO']"
                   
                    v-model="dataPagina.status"
                    outlined
                    dense
                    label="Status"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-select>
                </th>
                <th width="10%">
                  <v-autocomplete
                    outlined
                    label="Exibir"
                    dense
                    :items="resultadosPorPagina"
                    item-value="value"
                    item-text="label"
                    v-model="dataPagina.limit"
                    @change="listarOrcamentos({ ...dataPagina })"
                    class="mt-2"
                  ></v-autocomplete>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="o in getOrcamentos.data" :key="o.id">
                <td>{{ o.id }}</td>
                <td>{{ o.cliente ? o.cliente.nome : "" }}</td>
                <td>{{ $helper.formatDate(o.created_at) }}</td>
                <td>{{ $helper.formatReal(parseFloat(o.total))}}</td>
                <td>{{o.funcionario.nome_abreviado}}</td>
                <td>{{o.status}}</td>
                <td>
                  <TooltipButton
                  @click.native="$router.push({
                        name: 'orcamentoEditar',
                        params: { id: o.id },
                      })"
                  classButton="ml-2"
                  subtitle="Visualizar"
                  icon="search"
                  color="primary"
                  v-if="$helper.verificaPermissao('visualizar-orcamento')"
                />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <h3>Orçamentos: {{ getOrcamentos.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getOrcamentos.current_page"
          :length="getOrcamentos.last_page"
          @input="listarOrcamentos({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-actions>
     
    </v-card>
  </LayoutDashboard>
</template>

<script>
import OrcamentoService from "@/services/OrcamentoService";
import { mapGetters, mapActions } from "vuex";
var _ = require("lodash");

export default {
  data() {
    return {
      dataPagina: {
        id: "",
        cliente: "",
        funcionarioId: "",
        status: "EM ABERTO",
        data: "",
        limit: 20,
        page: 1,
      },
      resultadosPorPagina: [
        {
          label: "10",
          value: 10,
        },
        {
          label: "20",
          value: 20,
        },
        {
          label: "30",
          value: 30,
        },
        {
          label: "40",
          value: 40,
        },
        {
          label: "50",
          value: 50,
        },
      ],
    
    };
  },
  computed: {
    ...mapGetters(["getOrcamentos", "getFuncionarios"]),
  },
  methods: {
    ...mapActions(["listarOrcamentos", "cadastrarOrcamento", "listarFuncionarios"]),
    pesquisar() {
      this.listarOrcamentos(this.dataPagina);
    },
  },
  created() {
    this.listarOrcamentos(this.dataPagina);
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
    this.listarFuncionarios()
  },
};
</script>